<template>
  <el-card v-loading="tableLoading">
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-form-item :label="$t('device.connectionStatus')" prop="connectionStatus">
          <el-select v-model="form.connectionStatus" clearable>
            <el-option v-for="item in connectionStatusOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('device.serialNumber')" prop="serialNumber">
          <el-input v-model="form.serialNumber" clearable />
        </el-form-item>

        <el-form-item :label="$t('device.phone')" prop="phone">
          <el-input v-model.trim="form.phone" clearable />
        </el-form-item> 

        <el-form-item :label="$t('device.limits')" prop="limits">
          <el-input v-model.trim="form.limits" clearable/>
        </el-form-item>

        <el-form-item :label="$t('device.company')" prop="company">
          <el-input v-model.trim="form.company" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleEditor()">{{
            $t('btns.add')
          }}</el-button>
          <el-button size="mini" type="primary" @click="updateShow = true">{{
            $t('device.exportIn')
          }}</el-button>
          
          <el-button size="mini" type="primary">
            <router-link tag="a" :to="{ name: 'momohistory' }">
              {{ $t('device.history') }}
            </router-link>
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <div style="display: flex; flex-direction: row; align-items: center">
        <el-button size="mini" type="danger" @click="alldel()">{{
          $t('device.all.del')
        }}</el-button>
        <el-button size="mini" type="primary" @click="addUserDialogVisible = true">{{ $t('device.all.edit') }}
        </el-button>
        <el-button size="mini">
          {{ $t('device.all.offorturn') }}
          <el-switch v-model="connectionStatus" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#ff4949" @change="allSelectChange(val)">
          </el-switch>
        </el-button>
      </div>
    </el-row>
    <el-row>
      <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }" 
        :row-key="rowKey" @selection-change="handleSelectionChange"
        :row-style="DeviceRowStyle"
        :row-class-name="DeviceRowClass"
        :cell-style="DeviceCellStyle"
        >
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>

        <!-- <el-table-column type="index" label="#"></el-table-column>

        <el-table-column width="120px" prop="id" align="center" :label="$t('device.id')" /> -->
        <el-table-column width="120px" prop="serialNumber" align="center" :label="$t('device.serialNumber')" />
        <el-table-column width="120px" prop="phone" align="center" :label="$t('device.phone')" />
        <el-table-column width="120px" prop="connectionStatus" align="center" :label="$t('device.connectionStatus')">
          <template slot-scope="{ row }">
            {{ labelGet(row.connectionStatus) }}
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="limits" align="center" :label="$t('device.limits')">
          <template slot-scope="{ row }">
            {{ row.limits | toThousands }}
          </template>
        </el-table-column>
        <el-table-column width="220px" prop="monthLimits" align="center" :label="$t('device.monthLimits')">
          <template slot-scope="{ row }">
            {{ row.monthLimits | toThousands }}
          </template>
        </el-table-column>

        <el-table-column width="220px" prop="receivedDayMoney" align="center" :label="$t('device.receivedDayMoney')">
          <template slot-scope="{ row }">
            {{ row.receivedDayMoney | toThousands }}
          </template>
        </el-table-column>
        <el-table-column width="220px" prop="receivedTotalMoney" align="center"
          :label="$t('device.receivedTotalMoney')">
          <template slot-scope="{ row }">
            {{ row.receivedTotalMoney | toThousands }}
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="updateBy" align="center" :label="$t('device.lastcreator')" />
        <el-table-column width="220px" prop="connectionStatus" align="center" :label="$t('device.offstatus')">
          <template slot-scope="{ row }">
            <!-- <el-popconfirm
            :title="$t('orders.tip.danger')"
            @confirm="rowSelectChange(row.connectionStatus,row)"
          >
            <div slot="reference" class="cursor">
              <div class="por-n">
                <el-switch 
                v-model="row.connectionStatus" :active-value="1" :inactive-value="0" active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-text="$t('status.close')"
                  :inactive-text="$t('status.open')"
                  >
                </el-switch>
              </div>
            </div>
          </el-popconfirm> -->
            <el-popconfirm :title="$t('orders.tip.danger')" @confirm="rowSelectChange(1, row)">
              <el-button slot="reference" type="danger" size="mini">
                {{ $t('device.down.close') }}
              </el-button>
            </el-popconfirm>
            {{ row.connectionStatus ? $t('status.open') : $t('status.close') }}
            <el-popconfirm :title="$t('orders.tip.danger')" @confirm="rowSelectChange(0, row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('status.open') }}
              </el-button>
            </el-popconfirm>
            <!-- <el-switch v-model="row.connectionStatus" :active-value="1" :inactive-value="0" active-color="#13ce66"
              inactive-color="#ff4949" @change="(val) => rowSelectChange(val, row)">
            </el-switch> -->
          </template>
        </el-table-column>

        <el-table-column width="120px" prop="company" align="center" :label="$t('device.company')" />
        <el-table-column align="center" :label="$t('channel.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id" :title="$t('orders.tip.danger')"
              @confirm="handleEditor(row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.editor') }}
              </el-button>
            </el-popconfirm>
            <div style="margin: 10px; display: inline-block"></div>
            <el-popconfirm :ref="`popover-${row.id}`" :key="row.id + 's'" :title="$t('orders.tip.danger')"
              @confirm="handleDel(row)">
              <el-button slot="reference" type="danger" size="mini">
                {{ $t('btns.del') }}
              </el-button>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <v-editor ref="editor" :statusData="statusData" :serviceTypes="serviceTypes" :rules="formProps.form.rules"
      :channelTypeList="channelTypeList" :channelTypeData="channelTypeData" @doConfAdd="doConfAdd"
      @doConfUpdate="doConfUpdate" />

    <!-- 添加用户的对话框 -->
    <el-dialog :title="$t('accountmanager.addUser')" :visible.sync="addUserDialogVisible" width="50%"
      @close="addUserDialogVisible = false">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item :label="$t('device.limits')" prop="limits">
          <el-input v-model.trim="addForm.limits"></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.monthLimits')" prop="monthLimits">
          <el-input v-model.trim="addForm.monthLimits"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialogVisible = false">
          {{ $t('accountmanager.cancel') }}
        </el-button>
        <el-button type="primary" @click="allEditor">{{ $t('accountmanager.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('device.updates')" :visible.sync="updateShow" width="50%" @close="closeUpdate">
      <div class="drop-zone text-center">
        <input type="file" name="file"  ref="fileRef" @change="getExcel($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        <div>
          <div class="upload-icon">
            <el-button v-if="!fileName"> {{$t('device.selectFile')}}</el-button>
            <i class="el-icon-upload" style="font-size: 60px;margin-left: 10px;"></i>
          </div>
          <p style="line-height: 20px" ng-bind-html="self.langs.DEPOSITIMPORT_DragFile" class="ng-binding">
            {{$t('device.down.a1')}}
            <br />{{$t('device.down.a2')}}
            <!-- <em style="color: #409eff; cursor: pointer" @click="handleExport" href="/devices/import/template"
              target="_blank">{{$t('device.down.a3')}}</em> -->
          </p>
        </div>
        <div v-if="fileName" style="margin-top: 10px;">
          <span> {{$t('device.SelectedFile')}}:</span> <el-tag type="info">{{ fileName }}</el-tag>
        </div>
      </div>
      <div slot="footer" style="text-align: right;margin: 20px 0;">
            <el-button size="mini" type="warning" @click="handleExport">
              {{ $t('device.down.a3')}}
            </el-button>
            <el-button size="mini"  @click="updateShow = false">
              {{$t('device.down.close') }}
            </el-button>
            <el-button size="mini" type="primary" @click="uploadFile()">
              {{$t('device.down.confirm')}}
            </el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="historyShow" width="80%">
      <history></history>
    </el-dialog> -->
  </el-card>
</template>

<script>
  import {
    debounce
  } from 'lodash';
  import device_API from '@/api/device';
  import vEditor from './editor';
  import base from '@/mixin/base.js';
  // import history from './momohistory.vue'
  export default {
    mixins: [base],
    name: 'channelConf',
    components: {
      vEditor
    },
    data() {
      return {
        tableLoading:false,
        form: {
          //连接状态0断开1连接
          connectionStatus: null,
          //设备号
          serialNumber: '',
          //手机号
          phone: '',
          //限额
          limits: null,
          company:'',
        },
        historyShow: false,
        addForm: {
          limits: '',
          monthLimits: ''
        },
        pagination: {
          no: 1,
          size: 100
        },
        connectionStatusOption: this.$t('device.connectionStatusOption'),
        options: this.$t('device.add_connectionStatusOption'),
        channelTypeData: {},
        tableData: {},
        select: [],
        connectionStatus: 0,
        addUserDialogVisible: false,
        // 添加账号的验证规则对象
        addFormRules: {
          limits: [{
            required: true,
            message: this.$t('device.limits'),
            trigger: 'blur'
          }],
          monthLimits: [{
            required: true,
            message: this.$t('device.monthLimits'),
            trigger: 'blur'
          }]
        },
        updateShow: false,
        totalData: null,
        excelformData:null,
        fileName: '', 
      };
    },
    computed: {
      tableList() {
        return this.tableData.list || [];
      },
      channelTypeList() {
        return Object.keys(this.channelTypeData) || [];
      },
      channelCodeList() {
        if (Array.isArray(this.channelTypeData[this.form.channelType])) {
          return this.channelTypeData[this.form.channelType].length > 0 ?
            this.channelTypeData[this.form.channelType] :
            '';
        } else {
          return '';
        }
      },
      statusData() {
        return [{
            label: this.$t('status.success2'),
            type: 'success',
            value: 1
          },
          {
            label: this.$t('status.error2'),
            type: 'error',
            value: 0
          }
        ];
      }
    },
    created() {
      this.init();
    },
    mounted() {
      // this.getConfType();
      this.getTableData();
    },
    methods: {
      rowKey(row) {
        return row.id;
      },
      labelGet(index) {
        index = Number(index);
        return this.options[index] ? this.options[index].label : '';
      },
      async rowSelectChange(val, row) {
          let params = {
            ...row
          };
          params.connectionStatus = !val;
          const {
            data
          } = await device_API.update(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
          this.getTableData();
       
      },
      async alldel() {
        if (this.select.length == 0) {
          this.$message({
            type: 'info',
            message: '请先选择'
          });
          return;
        }

        this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            let ids = this.select.map((it) => it.id);
            let params = {
              //类型(1:momo,2:zalo,3:viettel)
              type: 1,
              //id 数组
              idList: ids
            };
            const {
              data
            } = await device_API.alldels(params);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
            this.getTableData();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      async allEditor() {
        if (this.select.length == 0) {
          this.$message({
            type: 'info',
            message: '请先选择'
          });
          return;
        }
        let ids = this.select.map((it) => it.id);
        let params = {
          //类型(1:momo,2:zalo,3:viettel)
          type: 1,
          //id 数组
          idList: ids,
          //批量修改限额(当天限额和当月限额)
          limits: this.addForm.limits,
          monthLimits: this.addForm.monthLimits
        };
        const {
          data
        } = await device_API.offOrturn(params);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.addUserDialogVisible = false;
          this.addForm = {
            limits: '',
            monthLimits: ''
          };
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },
      async handleExport() {
        const {
          data
        } = await device_API.downtemp();
        if (data) {
          const BLOB = data;
          const fileReader = new FileReader();
          fileReader.readAsDataURL(BLOB);
          fileReader.onload = (event) => {
            // 处理load事件。该事件在读取操作完成时触发
            // 新建个下载的a标签，完成后移除。
            let a = document.createElement('a');
            a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        } else {
          this.$message.error(this.$t('status.error'));
        }
      },
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            acc[key] = this.form[key];
            return acc;
          }, {})
        };
      },
      async allSelectChange(val) {
        if (this.select.length == 0) {
          this.$message({
            type: 'info',
            message: '请先选择'
          });
          return;
        }
        let ids = this.select.map((it) => it.id);
        let params = {
          //类型(1:momo,2:zalo,3:viettel)
          type: 1,
          //id 数组
          idList: ids,
          //批量开启1
          //批量关闭0
          connectionStatus: this.connectionStatus
        };
        const {
          data
        } = await device_API.offOrturn(params);
        if (data.code == 200) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },
      handleSelectionChange(list) {
        console.log(list);
        this.select = list;
      },
      init() {
        this.handleSearch = debounce(this._handleSearch, 300);
        /* ----------------------------- element -props ----------------------------- */
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {
              channelCode: [{
                required: true,
                message: this.$t('channel.rules.channelCode'),
                trigger: 'change'
              }],
              channelType: [{
                required: true,
                message: this.$t('channel.rules.channelType'),
                trigger: 'change'
              }],
            }
          }
        };
        this.serviceTypes = ['api', 'auto'];
      },

      /* ---------------------------------- 格式化数据 --------------------------------- */
      formatParams() {
        return {
          ...Object.keys(this.form).reduce((acc, key) => {
            if (this.form[key] === 0 || this.form[key]) {
              acc[key] = this.form[key];
            }
            if (key === 'channelCode') {
              acc.channelCode = '';
            }
            return acc;
          }, {})
          // ...this.pagination
        };
      },
      /* --------------------------------- 获取分页数据 --------------------------------- */
      async getTableData() {
        this.tableLoading = true;
        const {
          data
        } = await device_API.listpage({
          query: this.form,
          no: this.pagination.no,
          size: this.pagination.size
        });
        if (data && data.code == 200) {
          this.tableData = data.data;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message.error(data.msg);
        }
      },
      // uploadFile(){
      //   // this.$refs.fileRef.dispatchEvent(new MouseEvent('click'));
      //   device_API.doExportin(this.excelformData).then((response) => {
      //     if (response.code == 0||response.data.code==200) {
      //       this.$message({
      //         message: '导入成功',
      //         type: 'success'
      //       });
      //       this.getTable();
      //       // e.target.value = '';
      //       this.$refs.fileRef.value="";
      //       this.updateShow = false
      //     }
      //   });
      // },
      async uploadFile() {
      if (!this.excelformData) {
        this.$message({
          message: this.$t('device.down.selectfile'),
          type: 'warning'
        });
        return;
      }
      
      try {
        const response = await device_API.doExportin(this.excelformData);
        if (response.code == 200 || response.data.code == 200) {
          this.$message({
            message: this.$t('device.down.ImportSuccess'),
            type: 'success'
          });
          this.getTableData();
          this.excelformData = null; // 清空 excelformData
          this.$refs.fileRef.value = ""; // 清空文件输入框
          this.updateShow = false;
        }
      } catch (error) {
        this.$message({
          message: this.$t('device.down.Importfailed'),
          type: 'error'
        });
      }
    },
      getExcel(e) {
        this.excelformData = new FormData();
        const file = e.target.files[0];
        this.excelformData.append('file', e.target.files[0]);
        this.excelformData.append('userName', 'test');
        this.fileName = file.name; //显示上传文件名
        // device_API.doExportin(this.excelformData).then((response) => {
        //   if (response.code == 0) {
        //     this.$message({
        //       message: '导入成功',
        //       type: 'success'
        //     });
        //     this.getTable();
        //     e.target.value = '';
        //   }
        // });
      },

      closeUpdate() {
        this.excelformData = null; // 清空 excelformData
        this.fileName = ''; // 清空 fileName
        this.$refs.fileRef.value = ""; // 清空文件输入框
        this.updateShow = false
      },

      async doConfAdd(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await device_API.insert(params);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.$refs.editor.dialogVisible = false;
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },

      async doConfUpdate(formUpdate, cb) {
        const params = {
          ...formUpdate
        };
        const {
          data
        } = await device_API.update(params);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.$refs.editor.dialogVisible = false;
        } else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },
      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          //连接状态0断开1连接
          connectionStatus: null,
          //设备号
          serialNumber: '',
          //手机号
          phone: '',
          //限额
          limits: null
        };
      },
      handleEditor(row) {
        this.$refs.editor.init(row);
      },
      async handleDel(row) {
        const {
          data
        } = await device_API.deletes(row.id);
        if (data.code == 200) {} else {
          this.$message.error(data.msg);
        }
        this.getTableData();
      },
      _handleSearch() {
        this.$refs.form.validate(async (valid) => valid && this.getTableData());
      }
    }
  };

</script>

<style lang="scss" scoped>
  /deep/ .el-upload-dragger {
    width: 100%;
  }

  /deep/ .el-upload {
    width: 100%;
  }

  .drop-zone {
    text-align: center;
    position: relative;
    padding: 19px 0 0;
    margin-top: 10px;
    width: 100%;
    /* height: 150px; */
    color: #8f8f8f;
    box-sizing: border-box;
    /* background-color: #f5f5f5; */
    border-radius: 4px;
    border-top: dashed 3px transparent;
    cursor: pointer;

    input {
      width: 100%;
      position: absolute;
      font-size: 120px;
      right: 0;
      top: 0;
      opacity: 0;
      filter: alpha(opacity=0);
      cursor: pointer;
    }
    .upload-icon{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  /deep/ .el-button a {
    text-decoration: none;
    color: white;
  }

  .cursor {
    cursor: pointer;
  }
  .por-n {
    pointer-events: none;
    cursor: pointer;
  }
  /deep/ .moneysClass{
    background: #77e489 !important;
    &.el-table__row--striped{
      td.el-table__cell{
        background:transparent !important;
      }
    }
   &:hover{
    td.el-table__cell{
      background: #77e489 !important;
    }
    }

   
  }
</style>



// WEBPACK FOOTER //
// src/components/device/momoDevices.vue